const msa = {

    thumbSize:   'tiny',    // Size of photo thumbnails
    x2ThumbSize: 'small',   // Size of double-sized thumbnails
    viewSize:    'medium',  // Size of photo when selected for viewing
    markers:     {},        // Stores Leaflet map marker objects
    photoWidths: {},        // Stores photo widths that cannot be accurately calculated with CSS

    sections: ['map', 'about', 'other', 'photos'],

    tags: ['abstract', 'animal', 'bone', 'creature', 'face', 'nature', 'throw-up',
        'vehicle', 'angled', 'colorful', 'monochrome', 'realistic', 'stencil'],


    /**
     * Returns a function that, as long as it continues to be invoked, will not
     * be triggered. The function will execute after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     */
    debounce(fn, ms, immediate) {
        let timeout;
        return function () {
            const args = arguments,
               context = this,
               callNow = immediate && !timeout,
                 later = function () {
                    timeout = null;
                    !immediate && fn.apply(context, args);
                };
            clearTimeout(timeout);
            timeout = setTimeout(later, ms);
            callNow && fn.apply(context, args);
        };
    },


    /**
     * Sets the selected filters in the menu according to the filter Set.
     */
    setMenuFromFilter() {
        [...document.querySelectorAll('#menu .filter')].forEach(filter => {
            const addRemove = msa.filter.has(filter.id.substring(7)) ? 'add' : 'remove';
            filter.classList[addRemove]('selected');
        });
    },


    /**
     * Sets the location hash according to the filter Set.
     * @param {string} [section]
     */
    setHashFromFilter(section = elem.currentSection.id) {
        msa.isAutoHashChange = true;
        if (msa.filter.size === msa.tags.length) {
            location.replace('#');
            history.replaceState({ section }, '', location.pathname);  // Remove # from URL
        } else {
            location.replace('#filter=' + [...msa.filter].join(','));
        }
    },


    /**
     * Sets the filter Set according to the location hash.
     */
    setFilterFromHash() {
        const matches = location.hash.match(/filter=([^&]+)/i),
               filter = matches && matches[1] &&
                    decodeURIComponent(matches[1]).split(',')
                    .filter(tag => msa.tags.includes(tag));
        msa.filter = new Set((filter && filter.length) ? filter : msa.tags);
    },


    /**
     * Applies the tag filter to the specified section.
     * @param {string} section - If undefined then all sections
     */
    applyFilter(section) {
        (!section || section === 'photos') && msa.iso.arrange({
            filter: itemElem => [...itemElem.classList]
                .filter(tag => msa.filter.has(tag)).length
        });
        (!section || section === 'map') && msa.tags.forEach(tag => {
            const addRemove = msa.filter.has(tag) ? 'add' : 'remove';
            elem.sections.map.classList[addRemove](tag);
        });
    },


    /**
     * Gets the CSS transform needed to view a selected photo.
     * @return {string} transform
     */
    getSelectedTransform(photoElem) {
        const wallHeight = window.innerHeight * 0.8,
             photoHeight = window.innerHeight * 0.2 - 6.25,
                photoTop = parseFloat(photoElem.style.top),
               translate = (wallHeight / 2) - (photoHeight / 2) - photoTop - 5,
                   scale = wallHeight / photoHeight + 0.1;
        return `translateY(${translate}px) scale(${scale})`;
    },


    /**
     * Gets the size of photo thumbnails or photo when selected for viewing.
     * @return {string} size
     */
    getPhotoSize(context = 'thumb') {
        let height, size = 'large';
        switch (context) {
            case 'thumb':
                height = window.innerHeight * 0.2 - 7;
                break;
            case 'x2':
                height = window.innerHeight * 0.4 - 8;
                break;
            case 'selected':
                height = window.innerHeight * 0.8;
                break;
            default:
                console.error('Invalid context passed to getPhotoSize');
        }
        if (height <= 150) {
            size = 'tiny';
        } else if (height <= 300) {
            size = 'small';
        } else if (height <= 600) {
            size = 'medium';
        } else if (height <= 1200) {
            size = 'large';
        }
        return size;
    },


    /**
     * Shuffles the items of an array in place.
     * @param {Array} array
     */
    shuffleArray(array) {
        for (let i = array.length; i; i--) {
            let j = Math.floor(Math.random() * i);
            [array[i - 1], array[j]] = [array[j], array[i - 1]];
        }
    },


    /**
     * Calculates photo widths of different sized photos.
     * This is necessary because the CSS vh unit cannot be
     * relied on due to browser behavior on mobile touch devices.
     * For a detailed explanation see:
     * https://nicolas-hoizey.com/2015/02/viewport-height-is-taller-than-the-visible-part-of-the-document-in-some-mobile-browsers.html
     * @return {Object}
     */
    calcPhotoWidths() {
        const vh20 = window.innerHeight * 0.2,
               gap = 6.25,             // space between photos
             x2Gap = 8,
                lm = 1.3333333333333,  // landscape multiplier
                pm = 0.75,             // portrait multiplier
            widths = {
                landscape:   (vh20 - gap) * lm,
                x2landscape: ((vh20 - x2Gap) * lm) * 2 + (x2Gap * lm),
                portrait:    (vh20 - gap) * pm,
                x2portrait:  ((vh20 - x2Gap) * pm) * 2 + (x2Gap * pm)
                //mapPortrait: vh20 - gap
            };
        return widths;
    },


    /**
     * Invalidates photos loaded for viewing only if necessary.
     */
    invalidateLoaded(photos = [...document.querySelectorAll('.photo')]) {
        const viewSizes = ['tiny', 'small', 'medium', 'large'],
            oldViewSize = msa.viewSize;
        msa.viewSize = msa.getPhotoSize('selected');
        if (viewSizes.indexOf(msa.viewSize) > viewSizes.indexOf(oldViewSize)) {
            photos.filter(photoElem => photoElem.classList.contains('loaded')).forEach(photoElem => {
                photoElem.classList.remove('loaded');
            });
        }
    },


    /**
     * Sets photo widths using the width property on the style attribute.
     */
    resizePhotoWidths(photos = [...document.querySelectorAll('.photo')]) {
        photos.forEach(photoElem => {
            if (photoElem.classList.contains('landscape')) {
                photoElem.style.width = (photoElem.classList.contains('x2') ?
                    msa.photoWidths.x2landscape : msa.photoWidths.landscape) + 'px';
            } else if (photoElem.classList.contains('portrait')) {
                photoElem.style.width = (photoElem.classList.contains('x2') ?
                    msa.photoWidths.x2portrait : msa.photoWidths.portrait) + 'px';
            }
        });
    },


    /**
     * Calculates the approximate number of photos
     * that can be visible on the display at one time.
     * @return {number}
     */
    calcNumVisiblePhotos() {
        const photoWidth = window.innerHeight / 5 * 1.3333333333333;
        return (window.innerWidth / photoWidth * 4).toFixed(0);
    },


    /**
     * Inserts photos into the photos DOM element.
     * @param {Object} photoDefs - Photo definitions
     * @param {boolean} isInit - DOM element is empty
     */
    insertPhotos(photoDefs, isInit) {
        const ids = Object.keys(photoDefs),
           numVis = isInit ? msa.calcNumVisiblePhotos() : ids.length,
           markerPopups = {};
        let html = '';
        msa.shuffleArray(ids);

        ids.forEach((id, index) => {
            const photo = photoDefs[id],
               isSrcNow = index < numVis,
                   isX2 = Math.random() < 0.08,
                   size = isX2 ? msa.x2ThumbSize : msa.thumbSize,
                    src = ` src="images/photos/${size}/${photo.Suburb}/${id}.jpg"`,
                   tags = photo.Tags.join(' '),
                 orient = photo.Orientation || 'landscape',
              /* loaded = (size === msa.viewSize) ? ' loaded' : '', */
                classes = orient + (isX2 ? ' x2' : '') + (tags ? ' ' + tags : ''),
                  width = msa.photoWidths[isX2 ? 'x2' : '' + orient];

            html += `<div class="photo ${classes}" id="photo-${id}" style="width: ${width}px"><img alt="" draggable="false"${isSrcNow ? src : ''}><input class="photo-info" type="text" value="${tags}"></div>`;

            if (msa.markers[id]) {
                const popupHtml = `<div class="map-photo ${classes}" id="map-photo-${id}"><img draggable="false"${src}></div>`;
                if (isSrcNow) {
                    msa.markers[id].bindPopup(popupHtml, { closeButton: false });
                } else {
                    markerPopups[id] = popupHtml;
                }
            } /* else {
                console.warn('No map marker for photo-' + id);
            } */
        });
        elem.sections.photos.insertAdjacentHTML('beforeend', html);
        //elem.sections.photos.insertAdjacentHTML('beforeend', '<div id="shade"></div>');

        if (isInit) {
            const onIntersect = entries => {
                entries.forEach(entry => {
                  if (entry.intersectionRatio > 0) {
                    const img = entry.target;
                    observer.unobserve(img);
                    img.src = img.dataset.src;
                  }
                });
            };
            const observer = ('IntersectionObserver' in window)
                ? new IntersectionObserver(onIntersect, {
                    rootMargin: `0px ${Math.min(1920, window.innerWidth)}px`,
                    threshold: 0.01
                })
                : false;
            // TODO: First load photos that match applied filter
            const unloadedPhotos = ids.slice(numVis);
            let i = 0;
            const setSrc = () => {
                const id = unloadedPhotos[i],
               photoElem = document.getElementById('photo-' + id),
                 imgElem = photoElem.firstChild,
                    size = photoElem.classList.contains('x2') ? msa.x2ThumbSize : msa.thumbSize,
                     src = `images/photos/${size}/${photoDefs[id].Suburb}/${id}.jpg`;

                if (observer) {
                    imgElem.dataset.src = src;
                    observer.observe(imgElem);
                } else {
                    imgElem.src = src;
                }
                msa.markers[id] && msa.markers[id].bindPopup(markerPopups[id], { closeButton: false });
                ++i < unloadedPhotos.length && setSrc();
            },

            show = () => {
                window.scrollTo(0, 0);
                document.getElementsByTagName('header')[0].classList.add('open');
                document.getElementsByTagName('footer')[0].classList.add('open');
                setSrc();

                setTimeout(() => {
                    elem.msgText.innerHTML = 'Loading more photos...';
                    setTimeout(() => {
                        document.getElementById('icons').classList.add('show');
                        msa.showInFooter('nav');
                    }, 1800);
                }, 1200);
            };

            setTimeout(() => {
                elem.msgText.innerHTML = 'Roaming the streets...';
            }, 1);

            navigator.onLine ? (window.onload = show) : setTimeout(show, 1000);
        }
    },


    /**
     * Zooms in the selected photo and opens the corresponding map popup.
     * @param {node} photoElem
     */
    selectPhoto(photoElem) {
        elem.currentPhoto = photoElem;
        const photo = photoElem.id.substring(6);
        msa.setExif(photo);
        if (!photoElem.classList.contains('loaded')) {
            const isX2 = photoElem.classList.contains('x2'),
                thumbSize = isX2 ? msa.x2ThumbSize : msa.thumbSize;
            if (thumbSize !== msa.viewSize) {
                msa.loadSelectedPhoto(photoElem, thumbSize);
            }
        }
        photoElem.classList.add('front');
        photoElem.classList.add('selected');
        photoElem.style.transform = msa.getSelectedTransform(photoElem);
        const marker = msa.markers[photo];
        if (marker) {
            marker.openPopup();
        } else {
            msa.showInFooter('exif');
        }
    },


    /**
     * Zooms out the currently selected photo and closes the map popup.
     * @param {node} photoElem
     * @param {function} callback
     */
    unselectPhoto(photoElem = elem.currentPhoto, callback = null) {
        elem.currentPhoto = null;
        photoElem.style.transform = 'unset';
        photoElem.classList.remove('selected');
        msa.showInFooter('nav');
        setTimeout(() => {
            photoElem.classList.remove('front');
            msa.map.closePopup();
            callback && callback();
        }, 900);
    },


    /**
     * Formats a UNIX timestamp as a date.
     * @return {string} YYYY-MM-DD
     */
    formatDate(timestamp) {
        const date = new Date(timestamp * 1000),
              year = date.getFullYear(),
             month = date.getMonth() + 1,
               day = date.getUTCDate();
        return `${year}-${month}-${day}`;
    },


    /**
     * Gets a photo’s date taken, preferencing GPS date stamp.
     * @return {string} date
     */
    getPhotoDate(photo) {
        let date = 'N/A';
        if (typeof photo.GPSDateStamp === 'string') {
            date = photo.GPSDateStamp.replace(/:/g, '-');
        } else if (typeof photo.DateTimeOriginal === 'number') {
            date = msa.formatDate(photo.DateTimeOriginal);
        }
        return date;
    },


    /**
     * Inserts a larger photo into selected photo elem for better viewing.
     */
    loadSelectedPhoto(photoElem, thumbSize = msa.thumbSize) {
        const imgNode = photoElem.firstChild.cloneNode(false),
               imgSrc = imgNode.src.replace(thumbSize, msa.viewSize),
            infoInput = photoElem.querySelector('.photo-info');

        if (navigator.onLine) {
            infoInput.value = 'Enhancing...';
            infoInput.classList.add('show');
        }
        imgNode.src = '';
        imgNode.classList.add('overlay');

        imgNode.onload = (() => {
            infoInput.classList.remove('show');
            setTimeout(() => {
                infoInput.value = photos[photoElem.id.substring(6)].Tags.join(' ');
                photoElem.firstChild.remove();
                imgNode.classList.remove('overlay');
            }, 100);
        });
        imgNode.src = imgSrc;
        photoElem.classList.add('loaded');
        photoElem.appendChild(imgNode);
    },


    /**
     * Shows a photo’s basic EXIF data in the footer.
     */
    setExif(photoId) {
        const photo = photos[photoId] || {};
        elem.exifValues.date.innerHTML    = msa.getPhotoDate(photo);
        elem.exifValues.suburb.innerHTML  = photo.Suburb       || 'N/A';
        elem.exifValues.lat.innerHTML     = photo.GPSLatitude  || 'N/A';
        elem.exifValues.long.innerHTML    = photo.GPSLongitude || 'N/A';
        elem.exifValues.shutter.innerHTML = photo.ExposureTime ? `1/${(1 / photo.ExposureTime).toFixed(0)}` : 'N/A';
    },


    /**
     * Shows a section and hides the previous section.
     * @param {string} section - The section to show
     */
    showSection(section) {
        clearTimeout(msa.sectionTimeout);
        const prevSection = elem.currentSection;
        elem.currentSection = elem.sections[section];
        prevSection && prevSection.classList.remove('front');
        elem.currentSection.classList.add('front');
        elem.currentSection.classList.add('show');
        msa.sectionTimeout = setTimeout(() => {
            prevSection && prevSection.classList.remove('show');
        }, 1000);
    },


    /**
     * Sets section visibility according to the URL pathname.
     */
    setSectionFromUrl() {
        const pathname = window.location.pathname.substring(1);
        let section = 'photos';
        msa.sections.includes(pathname) && (section = pathname);
        msa.setDocumentTitle(section);
        history.replaceState({ section }, '', location.pathname);
        msa.showSection(section);
    },


    /**
     * Sets URL pathname and history state according to visible section.
     */
    setUrlFromSection(section = elem.currentSection.id.substring(4)) {
        msa.sections[section] || (section = 'photos');
        const pathname = (section === 'photos') ? '/' : section;
        history.pushState({ section }, '', pathname);
    },


    /**
     * Sets the tab/window title according to the section.
     */
    setDocumentTitle(section) {
        const title = 'Melbourne Street Art',
          subtitles = {
            photos: 'Murals & graffiti from the streets of Melbourne',
            map: 'Map',
            about: 'About',
            other: 'Other Sites'
        };
        document.title = `${title}: ${subtitles[section]}`;
    },


    /**
     * Manages the process of changing to another section.
     */
    changeSection(section) {
        msa.showSection(section);
        msa.setDocumentTitle(section);
        msa.setUrlFromSection(section);
        msa.setHashFromFilter(section);
    },

    /**
     * Shows the specified info element in the footer.
     */
    showInFooter(id) {
        const ids = ['nav', 'exif', 'msg'];
        ids.splice(ids.indexOf(id), 1);
        elem[ids[0]].classList.remove('show');
        elem[ids[1]].classList.remove('show');
        elem[id].classList.add('show');
    }

};
